import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import { Link } from "react-router-dom";

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="about-page">
      <PublicNav/>
      <section className="pt-32 pb-16 px-6 lg:px-12 max-w-4xl mx-auto">
        <div className="overline">About the Studio</div>
        <h1 className="font-serif font-light mt-4" style={{ fontSize: "clamp(44px, 6vw, 68px)", lineHeight: 1.05 }}>
          A quiet, careful studio on the Sunshine Coast.
        </h1>
        <p className="text-muted-foreground mt-6 leading-relaxed text-lg max-w-2xl">
          Luxe Media Walls is a small, specialist design and build studio based in Noosa. We compose bespoke entertainment walls for high-value residential projects — working directly with homeowners, and in close partnership with architects, interior designers and premium residential builders across the Sunshine Coast.
        </p>
        <p className="text-muted-foreground mt-4 leading-relaxed text-lg max-w-2xl">
          Each wall is unique. We select premium stone, timber and joinery finishes, integrate the audio, video, fireplace and lighting invisibly, and hand the project over as a single, resolved architectural gesture.
        </p>
      </section>

      <section className="bg-[color:hsl(var(--background-alt))] py-20">
        <div className="max-w-5xl mx-auto px-6 lg:px-12 text-center">
          <div className="overline">Location</div>
          <div className="font-serif text-4xl mt-3">Noosa, Queensland</div>
          <div className="text-muted-foreground mt-4">Serving the Sunshine Coast, Brisbane and select projects further afield.</div>
          <Link to="/enquiry" data-testid="btn-about-enquire" className="btn-accent inline-flex mt-8" style={{ padding: "14px 24px" }}>Request Consultation</Link>
        </div>
      </section>
      <PublicFooter/>
    </div>
  );
}
